module.exports = __webpack_public_path__ + "images/backgroundImg3.jpg";